module.exports = __webpack_public_path__ + "static/media/goup.3a19aa72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/investors/goup.svg
// module id = 2160
// module chunks = 0